import {
  getFirebaseToken,
  setFirebaseToken
} from '@ports/common/sessionStateSlice';
import { useAddUserDeviceTokensMutation } from '@ports/internal-services/user/userSlice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useFirebaseTokenRegister = () => {
  const dispatch = useDispatch();
  const firebaseToken = useSelector(getFirebaseToken);
  const [UserDeviceToken] = useAddUserDeviceTokensMutation();
  const userDeviceHandler = useCallback(
    (token: string) => {
      if (!token) return;
      if (firebaseToken === token) return; // Avoid unnecessary updates if the token hasn't changed
      const dataObj = {
        createUserDeviceTokens: {
          tokens: token || ''
        }
      };
      UserDeviceToken(dataObj)
        .then(() => {
          dispatch(setFirebaseToken(token));
        })
        .catch(err => {
          console.error('Error registering device token:', err);
        });
    },
    [firebaseToken]
  );
  return { userDeviceHandler };
};
